import { render, staticRenderFns } from "./BulkEditCalls.vue?vue&type=template&id=1fb772a5&scoped=true"
import script from "./BulkEditCalls.vue?vue&type=script&lang=js"
export * from "./BulkEditCalls.vue?vue&type=script&lang=js"
import style0 from "./BulkEditCalls.vue?vue&type=style&index=0&id=1fb772a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb772a5",
  null
  
)

export default component.exports